import roles from '../constants/roles';

// Accept a plain string: the current user's role flows through AuthContext
// (and many components) untyped, and these helpers only equality-check it.
export const isBooker = (role: string) => role === roles.booker;
export const isPrimaryUser = (role: string) => role === roles.primaryUser;
export const isBillPayer = (role: string) => role === roles.billPayer;
export const notBooker = (role: string) => !isBooker(role);
export const isCustomer = (role: string) =>
  isBooker(role) || isBillPayer(role) || isPrimaryUser(role);
